"use client";

import * as React from "react";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { cn } from "@/lib/utils";
import { TableRow } from "@/components/ui/table";
import config from "@/config";

interface ClickableTableRowProps {
  id: string;
  className?: string;
  children: React.ReactNode;
}

export function ClickableTableRow({
  id,
  className,
  children,
}: ClickableTableRowProps) {
  const router = useRouter();
  const { data: session } = useSession();

  function handleClick() {
    // If logged in, go directly to analysis with report
    if (session?.user) {
      router.push(`${config.routes.analysis.path}?report=${id}`);
    } else {
      // If not logged in, go to signin with callback
      const callbackUrl = `${config.routes.analysis.path}?report=${id}`;
      const signinUrl = `${
        config.routes.signin.path
      }?callbackUrl=${encodeURIComponent(callbackUrl)}`;
      router.push(signinUrl);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLTableRowElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  }

  return (
    <TableRow
      role="link"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={cn("cursor-pointer hover:bg-muted/40", className)}
      data-slot="clickable-row"
    >
      {children}
    </TableRow>
  );
}
